@if (auth.isAdmin) {
  <button
    class="btn btn-sm btn-danger ms-1 py-0 px-1 hide-print"
    data-bs-toggle="tooltip" data-placement="top" title="Delete">
    <i class="fa fa-trash"></i>
  </button>
}